import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function ProtectedRoute({ children, requiredRoles }) {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();
  const onboardingPath = "/onboarding";

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const requiresOnboardingFlow = Boolean(
    user.mustChangePassword || user.requiresOnboarding || user.requiresConfidentialityAgreement
  );

  if (requiresOnboardingFlow && location.pathname !== onboardingPath) {
    return <Navigate to={onboardingPath} replace />;
  }

  if (!requiresOnboardingFlow && location.pathname === onboardingPath) {
    return <Navigate to="/dashboard" replace />;
  }

  if (Array.isArray(requiredRoles) && requiredRoles.length > 0) {
    const normalizedRole = (user.role || "").toLowerCase();
    const isAllowed = requiredRoles.some((role) => normalizedRole === role.toLowerCase());
    if (!isAllowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return children;
}

export default ProtectedRoute;
